import { memo } from 'react'
import { makeStyles, createStyles } from '@mui/styles'
import Container from '@mui/material/Container'
import NoDataSVG from './no-data.svg'

const useStyles = makeStyles(() =>
  createStyles({
    content: {
      flexGrow: 1,
      margin: 'auto',
      maxWidth: '600px',
      padding: '0 15px',
      width: '100%',
      textAlign: 'center',
    },
    footNote: {
      fontSize: '14px',
      fontWeight: '500',
      color: 'gray',
      margin: '0 0 0 24px',
    },
  }),
)

const NoData = () => {
  const { content, footNote } = useStyles()

  return (
    <Container>
      <div className={content}>
        <h2>
          Für diese Kombination aus Nettokreditbetrag und Laufzeit gibt es
          derzeit keine passenden Kredite.
        </h2>
        <p>
          Bitte ändern Sie den Nettokreditbetrag oder die Laufzeit, um mehr
          Kreditangebote zu sehen.
        </p>
        <NoDataSVG />
      </div>
      <p className={footNote}>* Bonitätsabhängiger Zinssatz</p>
    </Container>
  )
}

export default memo(NoData)
